// extracted by mini-css-extract-plugin
module.exports = {"NavItem":"NavItem-module--NavItem--fLGJK","NavItemExternal":"NavItem-module--NavItemExternal--3Ckog NavItem-module--NavItem--fLGJK"};